import { render, staticRenderFns } from "./FeaturedVideos.vue?vue&type=template&id=4db61c1a&scoped=true&"
import script from "./FeaturedVideos.vue?vue&type=script&lang=js&"
export * from "./FeaturedVideos.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedVideos.vue?vue&type=style&index=0&id=4db61c1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db61c1a",
  null
  
)

export default component.exports